export enum PlaybackMode {
    Play,
    Pause,
    Stop
}
